import { render, staticRenderFns } from "./GenderInput.vue?vue&type=template&id=36bd8dd3&scoped=true&"
import script from "./GenderInput.vue?vue&type=script&lang=js&"
export * from "./GenderInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd8dd3",
  null
  
)

export default component.exports